@for (pc of pageContents; track pc) {
  @if (pc.PageContentTypeName == 'Grey Text Tile') {
    <app-grey-text-tile [pageContent]="pc"></app-grey-text-tile>
  }
  @if (pc.PageContentTypeName == 'Black Button' || pc.PageContentTypeName == 'Sidebar Black Button') {
    <app-black-button [pageContent]="pc"></app-black-button>
  }
  @if (pc.PageContentTypeName == 'Link Button' || pc.PageContentTypeName == 'Sidebar Link Button' || pc.PageContentTypeName == 'Tab Link Button') {
    <app-link-button [pageContent]="pc"></app-link-button>
  }
  @if (pc.PageContentTypeName == 'Grey Sidebar Box') {
    <app-grey-text-box-sidebar [pageContent]="pc"></app-grey-text-box-sidebar>
  }
  @if (pc.PageContentTypeName == 'Grey Bar') {
    <div class="grey-bar"></div>
  }
  @if (pc.PageContentTypeName == 'Tab List') {
    <app-dynamic-tab-list [pageContent]="pc"></app-dynamic-tab-list>
  }
  @if (pc.PageContentTypeName == 'Paragraph') {
    <app-generic-paragraph [pageContent]="pc"></app-generic-paragraph>
  }
}